import { useEffect } from 'react';
import getConfig from 'next/config';
import { NextSeo } from 'next-seo';
import { pushToDataLayer } from '../../services/gtmService';
import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';

import { DefaultLayout } from '../../components/Layouts';
import { NewCarFinance } from '../../components/NewCarFinance/NewCarFinance';
import { useVerticalContext } from '../../contexts/VerticalContext';
import { VERTICAL } from '../../helpers/verticals';

const {
  publicRuntimeConfig: { BASE_NEW_CAR_FINANCE },
} = getConfig();

function NewCarFinancePage(
  props: InferGetServerSidePropsType<typeof getServerSideProps>,
) {
  const { domain = '', platform } = props;

  const { updateVertical } = useVerticalContext();

  useEffect(() => {
    updateVertical(VERTICAL.MOTOR);
  }, [updateVertical]);

  useEffect(() => {
    pushToDataLayer({ platform });
    // TODO: Clean up this effect's dependencies. We're disabling this lint error for now so we can
    // clean up the lint logs. Ideally we should rewrite this code to be less error prone and trust
    // the lint rule's judgement.
    // https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=userstory/98606
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <NextSeo
        title="Apply for New Car Finance Today"
        description="Apply for a new car loan"
        noindex={true}
      />
      <DefaultLayout domain={domain} bg="WHITE">
        <NewCarFinance dschFinanceDomain={BASE_NEW_CAR_FINANCE} {...props} />
      </DefaultLayout>
    </>
  );
}

export const getServerSideProps: GetServerSideProps<
  { domain?: string; make: string; platform: string },
  {
    make: string;
    platform: string;
  }
> = async (ctx) => {
  const { params } = ctx;
  let { platform }: { platform?: string } = ctx.query;
  const make = params?.make as string;

  if (platform === undefined) {
    platform = 'web';
  }

  return {
    props: { make, platform },
  };
};

export default NewCarFinancePage;
